import { Roles } from "@timesheets/constants-common";
import { WebApplicationConstants } from "@/setup/WebApplicationConstants";
import { WireEntities } from "@timesheets/common";

export function getBestRole(currentSession: WireEntities.Session.ISession, roles: WireEntities.Roles.IRecruitmentAgencyRole[]): WireEntities.Roles.IRecruitmentAgencyRole {
  let role;
  if (currentSession.currentRoleId) {
    role = roles.find(role => role.id === currentSession.currentRoleId);
    if (role) {
      return role;
    }
  }

  const tenantRoles = roles.filter(role => role.recruitmentAgency.names.canonical.includes(WebApplicationConstants.currentTenant));
  if (tenantRoles.length === 0) {
    role = roles[0];
  } else {
    role = tenantRoles.find(role => role.type === Roles.RecruitmentAgencyAdministrationRole.TypeName);
    if (!role) {
      role = tenantRoles[0];
    }
  }

  return role;
}
